<template>
  <div class="min-h-full sticky top-0 z-50" v-if="getnavbar">
    <div
      as="nav"
      class="border-b border-gray-200 dark:border-dtheme-700 bg-white dark:bg-dtheme-900"
    >
      <div class="mx-auto px-3 sm:px-6 lg:px-3">
        <div class="flex h-10 sm:h-16 justify-between">
          <div class="flex justify-center items-center">
            <div class="hidden sm:block">
              <div class="app-logo-dark hidden sm:block w-40 mr-20">
                <img src="@/assets/definedge-dark-logo.png" />
              </div>
              <div class="app-logo-light hidden sm:block w-40 mr-20">
                <img src="@/assets/definedge-light-logo.png" />
              </div>
            </div>
            <button
              type="button"
              class="-m-2.5 p-2.5 text-gray-700"
              @click="toggleSideBar()"
            >
              <Bars3Icon class="h-6 w-6 dark:text-white" aria-hidden="true" />
            </button>
            <!-- <div
              class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8 dark:text-white"
            >
              <h1>Definedge Securities Dashboard</h1>
            </div> -->
            <div
              class="hidden sm:flex items-center ml-4 text-left text-sm font-semibold text-slate-600 dark:text-gray-200 capitalize"
            >
              <div>
                <div
                  class="text-sm font-semibold text-slate-700 dark:text-white capitalize"
                >
                  Hello
                  {{
                    firstname.charAt(0).toUpperCase() +
                    firstname.slice(1).toLowerCase()
                  }}
                  :
                  <span
                    class="font-medium text-slate-700 dark:text-slate-300"
                    >{{ ucc }}</span
                  >
                </div>
                <div class="text-xs text-slate-600 dark:text-slate-300">
                  Welcome to the Stock Market Ecosystem of Definedge Securities
                </div>
              </div>
            </div>
          </div>
          <div class="hidden sm:ml-6 sm:flex sm:items-center gap-2">
            <!-- <div v-if="km">{{ km }} - {{ km.contact }} - {{ km.category }}</div> -->
            <a
              href="https://www.definedgesecurities.com/get-started/"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center gap-2 px-4 py-2 bg-white text-blue-600 text-sm rounded-md shadow hover:bg-blue-600 hover:text-white transition duration-200 ring-1 ring-inset ring-blue-600 dark:ring-gray-700 dark:text-white dark:bg-dtheme-700 dark:hover:bg-blue-700"
            >
              <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-3 h-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg> -->
              Start Exploring
            </a>
            <!-- <a
              href="https://www.definedgesecurities.com/get-started/"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center text-sm gap-2 px-4 py-2 rounded-md bg-blue-600 text-white font-normal shadow hover:bg-blue-700 hover:shadow-lg transition duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
              Get Started with Definedge
            </a> -->
            <button
              type="button"
              class="text-gray-400 inline-flex justify-center items-center gap-x-1.5 rounded-md bg-white p-2 h-10 w-10 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:text-white dark:bg-dtheme-700 dark:ring-black-300"
              @click="toggleDark()"
            >
              <!-- <MoonIcon
                class="h-6 w-6 text-gray-500 dark:text-black-200"
                aria-hidden="true"
              /> -->
              <div class="moon-icon">
                <img src="@/assets/moon-dark.svg" />
              </div>
              <div class="sun-icon">
                <img src="@/assets/sun-light.svg" class="text-slate-500" />
              </div>
            </button>
            <!-- Profile dropdown -->
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex justify-center items-center gap-x-1.5 rounded-md bg-white p-2 h-10 w-10 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:text-white dark:bg-dtheme-700 dark:ring-black-300"
                >
                  {{ initials }}
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 origin-top-right divide-y divide-gray-100 dark:divide-black-300 rounded-md shadow-xl px-4 py-2 border border-gray-200 dark:border-black-300 bg-white dark:bg-dtheme-700"
                >
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ firstname }}
                  </div>
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ email }}
                  </div>
                  <div
                    class="py-2 flex items-center justify-start text-sm cursor-pointer"
                  >
                    <MenuItem v-slot="{ active }">
                      <a
                        @click="onLogout()"
                        :class="[
                          active ? ' text-gray-500' : 'text-gray-700',
                          'group flex items-center text-sm text-gray-400 dark:text-white',
                        ]"
                      >
                        <ArrowRightOnRectangleIcon
                          class="mr-3 h-5 w-5"
                          aria-hidden="true"
                        />
                        Sign Out
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
          <div class="items-center hidden sm:hidden">
            <!-- Mobile menu button -->
            <Menu as="div" class="relative inline-block text-left">
              <div>
                <MenuButton
                  class="inline-flex w-full justify-center gap-x-1.5 rounded-full bg-white px-2 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >
                  {{ initials }}
                </MenuButton>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems
                  class="absolute right-0 z-10 mt-2.5 origin-top-right divide-y divide-gray-100 dark:divide-black-300 rounded-md shadow-xl px-4 py-2 border border-gray-200 dark:border-black-300 bg-white dark:bg-dtheme-700"
                >
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ firstname }}
                  </div>
                  <div class="py-2 text-left text-gray-500 text-sm">
                    {{ email }}
                  </div>
                  <div
                    class="py-2 flex items-center justify-start text-sm cursor-pointer"
                  >
                    <MenuItem v-slot="{ active }">
                      <a
                        @click="onLogout()"
                        :class="[
                          active ? ' text-gray-500' : 'text-gray-700',
                          'group flex items-center text-sm text-gray-400 dark:text-white',
                        ]"
                      >
                        <ArrowRightOnRectangleIcon
                          class="mr-3 h-5 w-5"
                          aria-hidden="true"
                        />
                        Sign Out
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, defineComponent, computed, onMounted } from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
// import { MoonIcon } from "@heroicons/vue/24/outline";
import { useUserStore } from "../store/user";
import { ArrowRightOnRectangleIcon, Bars3Icon } from "@heroicons/vue/20/solid";
import { useCommonStore } from "@/store/commonStore";
import { useDark, useToggle } from "@vueuse/core";
export default defineComponent({
  components: {
    // MoonIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ArrowRightOnRectangleIcon,
    Bars3Icon,
  },
  setup() {
    const isDark = useDark();
    const toggleDark = useToggle(isDark);
    const userStore = useUserStore();
    const commonStore = useCommonStore();
    const state = reactive({
      getnavbar: computed(() => commonStore.getNavbar),
      email: computed(() => userStore.username.email),
      ucc: computed(() => userStore.username.ucc),
      firstname: computed(
        () => userStore.username.firstname + " " + userStore.username.lastname
      ),
      // initials: computed(() => {
      //   console.log("user is : ", userStore?.username);
      //   const fullnameArray = userStore?.username.firstname?.split("");
      //   console.log("initial letter : ", fullnameArray?.[0]?.split("")?.[0]);
      //   const firstchar = fullnameArray?.[0]?.split("")?.[0];
      //   const secondchar = fullnameArray?.[1]?.split("")?.[0];
      //   const finalchar = firstchar + secondchar;
      //   console.log("initial letter final : ", finalchar);
      //   return finalchar;
      // }),
      initials: computed(() => {
        console.log("user is : ", userStore?.username);
        const firstName = userStore?.username?.firstname || "";
        const lastName = userStore?.username?.lastname || "";
        const firstChar = firstName.charAt(0) || "";
        const secondChar = lastName.charAt(0) || "";
        const finalChar = firstChar + secondChar;
        console.log("Initials: ", finalChar);
        return finalChar;
      }),
    });
    const toggleSideBar = () => {
      commonStore.sidebarOpen = !commonStore.sidebarOpen;
    };
    const onLogout = () => {
      window.location.assign("/logout");
    };
    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const theme = urlParams.get("theme");

      if (theme === "dt" && !isDark.value) {
        toggleDark();
      } else if (theme === "lt" && isDark.value) {
        toggleDark();
      } else if (!theme && isDark.value) {
        toggleDark();
      }
    });
    return { ...toRefs(state), onLogout, toggleSideBar, toggleDark };
  },
});
</script>
